import i18n from "i18next";

import { Languages } from "@/constants/languages";
import { Routes as AppRoutes } from "@/constants/routes";

export const getLanguage = () => {
    let lng = i18n.language;

    if (typeof window !== "undefined" && window.location) {
        const isOfferUrl = window.location.pathname.includes(
            `/${AppRoutes.Both}/${AppRoutes.Offer}`
        );
        const isFunnelFoxUrl = window.location.pathname.includes(AppRoutes.FFPaywall);
        const isAgeWorkoutWithoutAIUrl = window.location.pathname.includes(
            AppRoutes.AgeWorkoutWithoutAI
        );
        const isBodyScanUrl = window.location.pathname.includes(AppRoutes.BodyScan);
        const isBodyScanAbsUrl = window.location.pathname.includes(AppRoutes.BodyScanAbs);
        const isBodyScanPlanUrl = window.location.pathname.includes(AppRoutes.BodyScanPlans);
        const isSeniorsUrl = window.location.pathname.includes(AppRoutes.Seniors);
        const isWeightLossUrl = window.location.pathname.includes(AppRoutes.WeightLoss);

        if (
            isOfferUrl ||
            isFunnelFoxUrl ||
            isAgeWorkoutWithoutAIUrl ||
            isBodyScanUrl ||
            isBodyScanAbsUrl ||
            isBodyScanPlanUrl ||
            isSeniorsUrl ||
            isWeightLossUrl
        ) {
            lng = Languages.English;
        }
    } else {
        lng = Languages.English;
    }

    return lng;
};
